import * as React from "react";
import { defaultViewSizes } from "./types.js";
import { useMediaQueries } from "./use-media-queries.js";
import { convertToUseBaseFontSizePx, getViewSizeFromDeviceInformation } from "./view-size-utils.js";
const defaults = {
  viewSizes: defaultViewSizes,
  validViewSize: defaultViewSizes.SMALL,
  setValidViewSize: (size) => 0
};
export const ViewportContext = React.createContext(defaults);
export const ViewportProvider = (props) => {
  const { viewSizes, baseFontSizePx, deviceInformation, children } = props;
  let validatedViewSizes = viewSizes || defaultViewSizes;
  if (baseFontSizePx) {
    validatedViewSizes = convertToUseBaseFontSizePx(validatedViewSizes, baseFontSizePx);
  }
  let deviceViewSize;
  if (deviceInformation) {
    deviceViewSize = getViewSizeFromDeviceInformation(validatedViewSizes, deviceInformation, baseFontSizePx);
  }
  const [viewSize, setViewSize] = React.useState(deviceViewSize || defaults.validViewSize);
  const validViewSize = useMediaQueries({
    viewSizes: validatedViewSizes,
    deviceInformation,
    baseFontSizePx
  });
  React.useEffect(() => {
    setViewSize(validViewSize);
  }, [validViewSize]);
  const viewportContext = {
    baseFontSizePx,
    validViewSize: viewSize,
    setValidViewSize: setViewSize,
    viewSizes: validatedViewSizes
  };
  return /* @__PURE__ */ React.createElement(ViewportContext.Provider, { value: viewportContext }, children);
};
export const useViewport = () => React.useContext(ViewportContext);
